import ApiService from "../core/service/ApiService"
import { apigateway } from "../intances/apigateway"

export function getSuppliers(tunnelData, username) {
  try {
    const API_URL_GET_SUPPPLIERS = `${tunnelData.apiUrl}middle-business-service/api/v2/user/suppliers?username=${username}`
    return apigateway(tunnelData)
      .get(API_URL_GET_SUPPPLIERS)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  } catch (error) {
    console.error(error)
    return null
  }
}

export async function getIsMultiProduct(token, supplierId, apiUrl) {
  try {
    const isMultiProductUrl = `${apiUrl}middle-business-service/api/v1/suppliers/${supplierId}/multi-product/active`
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "*/*"
    }
    return await ApiService.getForEvollisApi(isMultiProductUrl, headers)
  } catch (error) {
    console.error(error)
    return null
  }
}
